import * as actionTypes from "./actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import {
  getConceptGroupsAPI,
  createConceptGroupsAPI,
  updateConceptGroupsAPI,
  deleteConceptGroupsAPI
} from "@icarius-connection/api";

export const getConceptGroupsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getConceptGroupsAPI();

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: {
        rows: response.data.result,
      }
    });

    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    return e.response;
  }
};

export const createConceptGroupsAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE });
  try {
    let response = await createConceptGroupsAPI(data);

    dispatch({
      type: actionTypes.CREATE_FULFILLED,
      payload: {
        rows: response.data.result,
      }
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("conceptCreatedSuccessfully"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "DUPLICATED_DATA") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotHaveGroupsWithSameName"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.CREATE_REJECTED, payload: e });
    return e.response;
  }
};

export const updateConceptGroupsAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE });
  try {
    let response = await updateConceptGroupsAPI(data);

    dispatch({
      type: actionTypes.UPDATE_FULFILLED,
      payload: {
        rows: response.data.result,
      }
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("conceptUpdatedSuccessfully"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "DATA_IN_USE") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("conceptsInUse"), severity: "error" }));
    } else {
      if (e.response.data.status === "DUPLICATED_DATA") {
        dispatch(openSnackbarAction({ msg: getLocalizedString("cannotHaveGroupsWithSameName"), severity: "error" }));
      } else {
        dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
      }
    }
    dispatch({ type: actionTypes.UPDATE_REJECTED, payload: e });
    return e.response;
  }
};

export const deleteConceptGroupsAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE });
  try {
    let response = await deleteConceptGroupsAPI(data);

    dispatch({
      type: actionTypes.DELETE_FULFILLED,
      payload: {
        rows: response.data.result,
      }
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("conceptDeletedSuccessfully"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "DATA_IN_USE") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("conceptCannotBeDeletedBecauseItIsInUse"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.DELETE_REJECTED, payload: e });
    return e.response;
  }
};